<script>
	export let link;
</script>

<a class="navbar-item" href={link}>
	<slot></slot>
</a>

<style lang="scss">
</style>